import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { AppData, GlobalErrorHandler } from '..'

export class AppDataApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  getAppData = async () => {
    return this.fetchInstance.get(ApiEndpoints.APP_DATA).then((data): AppData => data)
  }
}
